export { Api } from './api/api';
export { User } from './user/user';
export { StorageProvider } from './storage/storage';
export { ClienteProvider } from './cliente/cliente';
export { PedidoProvider } from './pedido/pedido';
export { InterceptorProvider } from './interceptor/interceptor';
export { ProdutoProvider } from './produto/produto';



// WEBPACK FOOTER //
// ./src/providers/index.ts